module.exports = __webpack_public_path__ + "shutup.c7804973.png";